export enum ActionStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    RETIRED = 'RETIRED',
}

export type TestingAction = {
    id: string,
    // A HANDLE, not a script. Deliberately free text: an unregistered code is
    // legal — the executor fails OPEN and records an `unimplemented` observation.
    // Do not constrain this to a hardcoded list; a UI allow-list would break that seam.
    actionCode: string,
    name: string,
    // FOREIGN KEY into console-api's `Application` (FNP-976/979). Optional:
    // `applicationId: ID` is nullable on the API and is NOT validated at write
    // time — a dangling id is legal because an application can be archived
    // after this row references it.
    //
    // ⚠️ On Action this is only a CATALOG FACET (grouping/filtering); the
    // executor never reads it. The load-bearing one is TestDefinition's.
    applicationId?: string,
    status: ActionStatus,
    createdByUsername?: string,
    updatedByUsername?: string,
    created?: string,
    updated?: string,
}

export type TestingActionRecordFormProps = {
    record: TestingAction,
    // Returns a promise: the drawer AWAITS this and closes only on success,
    // so a rejection must be observable here (FNP-925). Typing it `void`
    // hid that contract and let the drawer close on a failed save.
    handleSubmit: (values: TestingAction) => void | Promise<unknown>,
    handleCancel: () => void,
}

export type ListTestingActions = {
    listActions: { items: TestingAction[], nextToken?: string }
}

export type GetTestingAction = {
    getAction: TestingAction
}

export type CreateTestingAction = {
    createAction: TestingAction
}

export type UpdateTestingAction = {
    updateAction: TestingAction
}

export type DeleteTestingAction = {
    deleteAction: string
}

export type SetTestingActionStatus = {
    setActionStatus: TestingAction
}
